export const GOOGLE_REVIEWS_URL = "https://share.google/bY6UFe2l6mW3DF47i";
export const YELP_URL =
  "https://www.yelp.com/biz/graystone-roofing-and-siding-east-petersburg";
